import RtTabs from './tabs';
export default {
  name: 'RtContentTabs',
  props: {
    size: {
      type: String,
      default: ''
    }
  },

  render(h) {
    let { size } = this;
    return h(
      'div',
      {
        ['class']: ['rt-content-tab', `tab-${size}`]
      },
      [
        h(
          RtTabs,
          {
            attrs: this.$attrs,
            props: this.$props,
            on: this.$listeners
          },
          this.$slots.default
        )
      ]
    );
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/tabs/rtContentTabs.js